<template>
  <div>
    <form-field-editor
      ref="noteField"
      placeholder="write your note here..."
      v-model="form.body"
      type="note"
    ></form-field-editor>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";

  export default {
    name: "NoteForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        defaultForm: {
          body: '',
        },
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
    },
    methods: {
      update() {
        return this.$api.notes.update(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Note was updated',
              type: 'is-success'
            });

            return res;
          })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
